import * as React from "react";

function SvgInfoLogo(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} {...props}>
      <path
        d="M13.5 0a13.411 13.411 0 00-9.546 3.954A13.413 13.413 0 000 13.5a13.411 13.411 0 003.954 9.546A13.411 13.411 0 0013.5 27a13.413 13.413 0 009.546-3.954A13.411 13.411 0 0027 13.5a13.413 13.413 0 00-3.954-9.547A13.413 13.413 0 0013.5 0zm0 25.1a11.537 11.537 0 01-4.514-.908A11.625 11.625 0 015.3 21.706a11.548 11.548 0 01-2.489-3.689A11.515 11.515 0 011.9 13.5a11.546 11.546 0 01.909-4.515A11.648 11.648 0 015.294 5.3a11.548 11.548 0 013.689-2.49A11.515 11.515 0 0113.5 1.9a11.529 11.529 0 014.515.91A11.627 11.627 0 0121.7 5.294a11.557 11.557 0 012.487 3.69A11.515 11.515 0 0125.1 13.5a11.52 11.52 0 01-.91 4.514A11.537 11.537 0 0121.7 21.7a11.548 11.548 0 01-3.686 2.489 11.5 11.5 0 01-4.514.911zm-.079-20.237a.95.95 0 00-.949.95.95.95 0 00.949.949.95.95 0 00.95-.949.951.951 0 00-.95-.948zm0 3.56h-2.532a.95.95 0 00-.949.949.95.95 0 00.949.95h1.583V18.6h-2.247a.951.951 0 00-.95.95.95.95 0 00.95.949h6.391a.95.95 0 00.95-.949.951.951 0 00-.95-.95H14.37V9.369a.95.95 0 00-.949-.944z"
        fill="#3c4252"
      />
    </svg>
  );
}

export default SvgInfoLogo;
